export const INSIGHTS_COPY = {
  heading: 'For you',
  loadError: 'Insights are temporarily unavailable.',
  showMembers: 'Show details',
  hideMembers: 'Hide details',
  markRead: 'Mark insight as read',
};
